const CLEAR_COLLECTED_ORDER = 'CLEAR_COLLECTED_ORDER';
const CLEAR_PLACE_COLLECTED_ORDER = 'CLEAR_PLACE_COLLECTED_ORDER';
const PLACE_COLLECTED_ORDER = 'PLACE_COLLECTED_ORDER';
const PLACE_COLLECTED_ORDER_FULFILLED = 'PLACE_COLLECTED_ORDER_FULFILLED';
const PLACE_COLLECTED_ORDER_REJECTED = 'PLACE_COLLECTED_ORDER_REJECTED';
const TOGGLE_COLLECTED_ORDER = 'TOGGLE_COLLECTED_ORDER';
const UPDATE_COLLECTED_ORDER = 'UPDATE_COLLECTED_ORDER';

export {
  CLEAR_COLLECTED_ORDER,
  CLEAR_PLACE_COLLECTED_ORDER,
  PLACE_COLLECTED_ORDER,
  PLACE_COLLECTED_ORDER_FULFILLED,
  PLACE_COLLECTED_ORDER_REJECTED,
  TOGGLE_COLLECTED_ORDER,
  UPDATE_COLLECTED_ORDER,
};
